class AuthService {

    constructor(api) {
        this.api = api;
    }

    logout(onSuccess) {
        return this.api.get('/logout/cas', {headers: {'Content-Type': 'text/plain'}}).then(onSuccess).catch(() => console.log("error logout"))
    }

    token(onSuccess, onError) {
        return this.api.get('/token', {headers: {'Content-Type': 'text/plain'}}).then(onSuccess).catch(onError)
    }

}

export default AuthService


// WEBPACK FOOTER //
// ./src/auth/AuthService.js